import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.find";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading } from '@/decorators';

var BillingDeadlineRulePage = function (_super) {
  __extends(BillingDeadlineRulePage, _super);

  function BillingDeadlineRulePage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.loadingStatus = false;
    _this.columns = [];
    _this.dataList = [];
    _this.countryList = [];
    return _this;
  }

  BillingDeadlineRulePage.prototype.onVisibleChange = function (isShow) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!isShow) return [3, 2];
            this.initColumns();
            return [4, this.queryBillingDeadlineRuleList()];

          case 1:
            _a.sent();

            _a.label = 2;

          case 2:
            return [2];
        }
      });
    });
  };

  BillingDeadlineRulePage.prototype.initColumns = function () {
    this.columns = [{
      title: this.t('主体所属国家/地区'),
      dataIndex: 'country_code',
      align: 'center',
      scopedSlots: {
        customRender: 'country_code'
      },
      width: 150
    }, {
      title: this.t('开票期限'),
      dataIndex: 'deadline_days',
      align: 'center',
      scopedSlots: {
        customRender: 'deadline_days'
      },
      width: 150
    }];
  };

  BillingDeadlineRulePage.prototype.queryBillingDeadlineRuleList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.base.queryBillingDeadlineRuleList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.dataList = data;
            return [2];
        }
      });
    });
  };

  BillingDeadlineRulePage.prototype.handleConfirm = function () {
    this.visible = false;
  };

  BillingDeadlineRulePage.prototype.queryCountryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.common.queryCountryList()];

          case 1:
            data = _a.sent().data;
            this.countryList = data;
            return [2];
        }
      });
    });
  };

  BillingDeadlineRulePage.prototype.created = function () {
    this.queryCountryList();
  };

  BillingDeadlineRulePage.prototype.getCountryText = function (code) {
    var item = this.countryList.find(function (country) {
      return country.code === code;
    });
    return item ? item.name : code;
  };

  __decorate([Watch('visible', {
    immediate: true
  })], BillingDeadlineRulePage.prototype, "onVisibleChange", null);

  __decorate([loading('loadingStatus')], BillingDeadlineRulePage.prototype, "queryBillingDeadlineRuleList", null);

  BillingDeadlineRulePage = __decorate([Component({})], BillingDeadlineRulePage);
  return BillingDeadlineRulePage;
}(Vue);

export default BillingDeadlineRulePage;